import { lazy } from "react";

export interface IProps {
  onClose?: () => void;
}

export const LazyMobileMenu = lazy(() =>
  Promise.all([
    import(
      /* webpackChunkName: "retailer-mobile-menu" */ "@faire/deprecated-retailer-visitor-shared/components/Header/mobile/MobileMenu/MobileMenu"
    ),
    import("@faire/web/slate/Modal/reactModal"),
  ]).then(([mobileMenuModule, reactModalModule]) => {
    reactModalModule.initializeReactModal();
    return { default: mobileMenuModule.MobileMenu };
  })
);
